import {
  Component,
  ViewChildren,
  ElementRef,
  QueryList,
} from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { FormViewService } from '@xilo-mono/form-contracts';

@Component({
  selector: 'xilo-mono-form-viewer-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss', '../../form-viewer.component.scss']
})
export class CustomRadioComponent extends FieldType {
  @ViewChildren('radioInput') radioInputs!: QueryList<ElementRef<HTMLInputElement>>;
  isInvalid = false;
  errorMessage = false;

  constructor(private formViewService: FormViewService) {
    super();
  }

  get isMobile() {
    return window?.innerWidth <= 767;
  }

  ngAfterViewInit(): void {
    this.updateTabIndexes();
    if (!this.formControl.value && this.radioInputs.first) {
      // const firstInput = this.radioInputs.first.nativeElement;
      // this.onRadioChange(firstInput.value);
    }
  }

  checked(value: string) {
    return this.formControl?.value === value;
  }

  onRadioChange(value: string): void {
    this.formControl.setValue(value);
    this.emitInteraction();
    this.updateForm();
    this.updateTabIndexes();
  }

  onArrowKeydown(event: KeyboardEvent, index: number): void {
    const radios = this.radioInputs.toArray();
    const key = event.key;
  
    let newIndex = index;
  
    if (key === 'ArrowRight' || key === 'ArrowDown') {
      event.preventDefault();
      newIndex = (index + 1) % radios.length;
    } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
      event.preventDefault();
      newIndex = (index - 1 + radios.length) % radios.length;
    }
  
    const nextInput = radios[newIndex]?.nativeElement;
    if (nextInput) {
      nextInput.focus();
      if (!this.checked(nextInput.value)) {
        nextInput.checked = true;
        this.onRadioChange(nextInput.value);
      }
      this.updateTabIndexes();
    }
  }  

  updateForm() {
    if (this.to.className !== 'xilo-input') {
      this.formViewService.updateForm.next(true);
    }
  }

  styleRadios(options: any[]) {
    // Check for singleColumn in multiple possible locations with priority order
    const isSingleColumn = 
      // First check this.to (component's own template options)
      this.to?.singleColumn !== undefined ? this.to.singleColumn :
      // Then check field.parent.templateOptions (parent component's template options)
      this.field?.parent?.templateOptions?.singleColumn !== undefined ? this.field.parent.templateOptions.singleColumn :
      // Then check field.parent.parent.templateOptions (grandparent component's template options)
      this.field?.parent?.parent?.templateOptions?.singleColumn !== undefined ? this.field.parent.parent.templateOptions.singleColumn :
      // Default to false if not found anywhere
      false;

    if (isSingleColumn) {
      return { 'flex-flow': 'column' };
    }

    if (!this.isMobile && options && options.length && options.length > 3) {
      return { 'flex-flow': 'row wrap' };
    }
  }

  styleRadio(options: any[]) {
    if (!this.isMobile && options && options.length && options.length > 3) {
      return { width: 'auto' };
    }
  }

  private updateTabIndexes(): void {
    const radios = this.radioInputs.toArray();
    radios.forEach((r) => {
      r.nativeElement.tabIndex = this.checked(r.nativeElement.value) ? 0 : -1;
    });
  }

  private emitInteraction(): void {
    const input = this.radioInputs.find(r => r.nativeElement.value === this.formControl.value);
    input?.nativeElement.dispatchEvent(new CustomEvent('xiloRadioInteraction', { bubbles: true, composed: true }));
  }

  radioKey() {
    return `${this.field.key || 'field'}_${this.field.parent?.key || '0'}`;
  }
}
